import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import {
  ComposedChart,
  Area,
  Bar,
  ResponsiveContainer,
  Line,
} from 'recharts';
import { GENOME_PERCENTILE } from '../../constants';

export default function ComposedAreaChart ({ height = 150, value = 0 }) {
  const data = useMemo(() => {
    if (value) {
      const pv = parseFloat((value / 100 * 60).toFixed(2))
      let pv_x = pv - 1
      if (value < 25 || value > 80) pv_x = pv
      
      const result = [...GENOME_PERCENTILE].map((item => ({
        x: item.x,
        y: item.y,
      })))
      const activeLine = result.sort((a, b) => b.x - a.x).find(item => item.x < pv_x)
      // result.push({
      //   pv: activeLine.y + 0.005,
      //   x: pv - 1,
      //   y: activeLine.y + 0.005,
      // })
      return result.map((item => {
        let temp = item
        if (temp.x === activeLine.x) {
          temp = {
            pv: activeLine.y,
            x: temp.x,
            y: activeLine.y,
          }
        }
        return temp
      })).sort((a, b) => a.x - b.x)
      // return result.sort((a, b) => a.x - b.x)
    }
    return []
  }, [value])
  return (
    <Box>
      <ResponsiveContainer width="100%" height={height}>
        <ComposedChart
          width={500}
          height={150}
          data={data}
          margin={{
            top: 10,
            right: -0,
            bottom: 4,
            left: -0,
          }}
        >
          <Area type="monotone" dataKey="y" fill="#5B87EF" stroke="#5B87EF" />
          <Bar dataKey="pv" barSize={2} fill="#4266B8" />
          <Line
            strokeWidth={1}
            data={data}
            dot={false}
            type="monotone"
            dataKey="y"
            stroke="#4266B8"
            tooltipType="none"
          />
        </ComposedChart>
      </ResponsiveContainer>
      <Box
        sx={{
          background: 'linear-gradient(102.83deg, #39B195 9.28%, #FED46A 50.85%, #E73E3E 90.72%)',
          width: '100%',
          height: '8px',
          borderRadius: '10px',
        }}
      />
      <Box
        sx={{
          // display: 'grid',
          // gridTemplateColumns: 'auto auto auto auto auto'
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        {[0, 20, 40, 60, 80, 100].map((val, idx) => (
          <Box key={idx}>
            <Typography variant='subText' color='primary.mediumGray'>{val}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}